<template>
    <div>
        <div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
            <label class="mb-0 mr-1 font-weight-bold"><i class="fas fa-mobile-alt text-primary"></i> Filter Pengirim (Device):</label>
            <select class="form-control form-control-sm w-auto" v-model="deviceFilter" @change="onDeviceFilterChange">
                <option value="">Semua Device</option>
                <option v-for="d in devices" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
        </div>
        <vue-good-table mode="remote" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: false
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    
                    <router-link :to="'/outgoing/detail?id=' + props.row.id">
                        <a class="btn btn-sm  btn-primary text-white margin5">Detail</a>
                    </router-link>
                    
                    
                    <a v-on:click="resendOutgoing(props.row.id)" v-if="props.row.status == 'gagal' && props.row.note != 'Nomor tidak terdaftar' && props.row.note != 'Blast list stopped by user'"  class="btn btn-sm btn-warning text-white margin5">
                        Kirim Ulang
                    </a>
                    
                    <a v-on:click="deleteOutgoing(props.row.id)" class="btn btn-sm  btn-danger text-white margin5">
                        Hapus
                    </a>
                </span>
                <span v-else-if="props.column.field == 'text'">
                    <div v-if="props.row.message_type == 'text'">
                        {{ cutString(props.row.text) }}
                        <div v-if="props.row.file">
                            <br>
                            <div class="card">
                                <div class="card-body">
                                    <center>
                                        <b>Document</b>
                                        <br>
                                        <a :href="props.row.file" target="_blank"> Open File </a>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="props.row.message_type == 'button'">
                        <div class="card thick-border">
                            <div class="card-body">
                                <h6 style="text-align: center;">BUTTON MESSAGE</h6>
                                <hr>
                                {{ cutString(props.row.text) }}
                                <br>
                                <div v-if="props.row.file">
                                    <br>
                                    <div class="card">
                                        <div class="card-body">
                                            <center>
                                                <b>Document</b>
                                                <br>
                                                <a :href="props.row.file" target="_blank"> Open File </a>
                                            </center>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div v-for="button in props.row.parsedButton" v-bind:key="button.index">
                                    <div class="card thick-border">
                                        <div class="card-body" style="padding:10px">
                                            <div v-if="button.button_type == 'quickReplyButton'">
                                                <!-- <p style="font-size:10px" class="float-right">[QUICK REPLY BUTTON]</p>
                                                <br> -->
                                                <h6 style="text-align:center">
                                                    {{ button.display_text }}
                                                </h6>
                                            </div>
                                            <div v-else-if="button.button_type == 'urlButton'">
                                                <!-- <p style="font-size:10px" class="float-right">[URL BUTTON]</p>
                                                <br> -->
                                                <h6 style="text-align:center">
                                                    <a :href="button.button_action" target="_blank"><i class="fas fa-globe fs-16"></i>&nbsp;{{ button.display_text }}</a>
                                                </h6>
                                            </div>
                                            <div v-else-if="button.button_type == 'callButton'">
                                                <!-- <p style="font-size:10px" class="float-right">[CALL BUTTON]</p>
                                                <br> -->
                                                <h6 style="text-align:center">
                                                    <a :href="'tel:' +button.button_action"><i class="fas fa-phone fs-16"></i>&nbsp;{{ button.display_text }}</a>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                </div>
                                <a style="color:black;font-size: 12px;">{{ props.row.footer }}</a>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="props.row.message_type == 'list'">
                        <div class="card thick-border">
                            <div class="card-body">
                                <h6 style="text-align: center;">LIST MESSAGE</h6>
                                <hr>
                                <b>{{ props.row.parsedList.title }}</b>
                                <p>{{ cutString(props.row.text) }}</p>
                                <button class="btn btn-outline-success btn-block">{{ props.row.parsedList.buttonText }}</button>
                                <br>
                                <div v-for="s in props.row.parsedList.sections" v-bind:key="s.index" style="padding-top:10px">
                                    <div class="card thick-border">
                                        <div class="card-body" style="padding:5px">
                                            <b>{{ s.title }}</b>
                                            <p>{{ s.description }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="props.row.message_type == 'media' || props.row.message_type == 'image' || props.row.message_type == 'video' || props.row.message_type == 'audio' || props.row.message_type == 'file' || props.row.message_type == 'document' || props.row.message_type == 'sticker'">
                        {{ cutString(props.row.text) }}
                        <div v-if="props.row.file">
                            <br>
                            <div class="card">
                                <div class="card-body">
                                    <center>
                                        <b>Document</b>
                                        <br>
                                        <a :href="props.row.file" target="_blank"> Open File </a>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        {{ cutString(props.row.text) }}
                    </div>
                </span>
                <span v-else-if="props.column.field == 'jadwal'">
                    {{ convertDateToLocal(props.row.jadwal) }}
                </span>
                <span v-else-if="props.column.field == 'delivery_schedule'">
                    {{ convertDateToLocal(props.row.delivery_schedule) }}
                </span>
                <span v-else-if="props.column.field == 'status'">
                    <span v-if="props.row.status == 'terkirim'" class="badge badge-success">Terkirim</span>
                    <span v-else-if="props.row.status == 'dalam antrian' || props.row.status == 'menunggu jadwal'"
                        class="badge badge-warning text-white">Dalam Pengiriman</span>
                    <span v-else-if="props.row.status == 'dijadwalkan'"
                        class="badge badge-secondary text-white">Menunggu Jadwal</span>
                    <span v-else-if="props.row.status == 'menunggu device terkoneksi'"
                        class="badge badge-warning text-white">Menunggu Device Terkoneksi</span>
                    <div v-else-if="props.row.status == 'gagal'">
                        <span class="badge badge-danger">
                            Gagal
                        </span>
                        <div v-if="props.row.note == 'Nomor tidak terdaftar'">
                            <span class="badge badge-danger">
                                {{ props.row.note }}
                            </span>
                        </div>
                        <div v-if="props.row.note == 'Blast list stopped by user'">
                            <span class="badge badge-danger">
                                Pengiriman Dibatalkan
                            </span>
                        </div>
                    </div>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
        <div class="d-flex align-items-center justify-content-between mt-2">
            <div class="d-flex align-items-center">
                <label class="mr-2 mb-0">Per page</label>
                <select class="form-control form-control-sm w-auto" v-model.number="table.serverParams.limit" @change="onLimitChange">
                    <option :value="10">10</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </div>
            <div class="d-flex align-items-center">
                <span class="text-muted small mr-3" v-if="table.rows && table.rows.length">Showing {{ table.rows.length }} items</span>
                <div class="btn-group" role="group" aria-label="Pagination controls">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        :disabled="cursorStack.length === 0 || table.isLoading"
                        @click="goPrevPage"
                        title="Go to previous page"
                        aria-label="Previous">
                        <i class="fas fa-chevron-left"></i>
                        <span class="d-none d-sm-inline"> Previous</span>
                    </button>
                    <button
                        class="btn btn-sm btn-outline-primary"
                        :disabled="!hasMore || table.isLoading"
                        @click="goNextPage"
                        title="Go to next page"
                        aria-label="Next">
                        <span class="d-none d-sm-inline">Next </span>
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                table: {
                    isLoading: true,
                    columns: [{
                            label: "Tujuan",
                            field: "to",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "15%",
                        },
                        {
                            label: "Pesan",
                            field: "text",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "40%",
                        },
                        {
                            label: "Jadwal",
                            field: "jadwal",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "15%",
                        },
                        {
                            label: "Jadwal Pengiriman Aktual",
                            field: "delivery_schedule",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "15%",
                        },
                        {
                            label: "Status",
                            field: "status",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "10%",
                        },
                        {
                            label: "Action",
                            field: "action",
                            sortable: false,
                            width: "20%",
                        },
                    ],
                    rows: [],
                    serverParams: {
                        columnFilters: {},
                        sort: [{
                            field: "",
                            type: "",
                        }, ],
                        limit: 10,
                        last_id: null,
                    },
                },
                hasMore: false,
                cursorStack: [],
                devices: [],
                deviceFilter: "",
            };
        },
        mounted() {
            this.fn = () => {
                this.loadItems();
            }
            this.$root.$on("refresh_table", this.fn);
            this.loadDevices();
            this.loadItems();
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fn);
        },
        methods: {
            cutString(string){
                if(string == null || string == "") return ""
                
                if(string.length > 40){
                    string = string.slice(0, 40) + "..."
                }

                return string
            },
            convertDateToLocal(date) {
                return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
            },
            async deleteOutgoing(id) {
                try {
                    let response = await this.$store.dispatch("outgoing_delete", {
                        id: id
                    });
                    this.loadItems();
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error("Server error");
                }
            },
            async resendOutgoing(id){
                try {
                    let response = await this.$store.dispatch("outgoing_resend", {
                        message_id: parseInt(id)
                    });
                    this.loadItems();
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error("Server error");
                }
            },
            updateParams(newProps) {
                this.table.serverParams = Object.assign({},
                    this.table.serverParams,
                    newProps
                );
            },
            async loadDevices() {
                try {
                    let res = await this.$store.dispatch("device_list_all", { limit: 1000, page: 1 });
                    this.devices = (res.data && res.data.data && res.data.data.devices) ? res.data.data.devices : [];
                } catch (err) {
                    this.devices = [];
                }
            },
            onDeviceFilterChange() {
                this.cursorStack = [];
                this.updateParams({ last_id: null });
                this.loadItems();
            },
            onLimitChange() {
                this.updateParams({
                    limit: this.table.serverParams.limit,
                    last_id: null
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    }, ],
                    last_id: null,
                });
                this.cursorStack = [];
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(Object.assign({}, params, { last_id: null }));
                this.cursorStack = [];
                this.loadItems();
            },
            goPrevPage() {
                if (this.cursorStack.length > 0) {
                    const prevCursor = this.cursorStack.pop();
                    this.updateParams({ last_id: prevCursor });
                    this.loadItems();
                }
            },
            goNextPage() {
                if (this.hasMore) {
                    // push current cursor before moving forward
                    this.cursorStack.push(this.table.serverParams.last_id);
                    const rows = this.table.rows || [];
                    const nextCursor = rows.length > 0 ? rows[rows.length - 1].id : null;
                    this.updateParams({ last_id: nextCursor });
                    this.loadItems();
                }
            },
            async loadItems() {
                this.table.isLoading = true
                try {
                    let response = await this.getFromServer(this.table.serverParams);
                    let outgoing = response.data.data.outgoings;
                    for (let i = 0; i < outgoing.length; i++) {
                        if(outgoing[i].message_type == "button"){
                            let parse = JSON.parse(outgoing[i].data)
                            outgoing[i].parsedButton = parse
                            outgoing[i].footer = parse?.[0].footer
                        }else if(outgoing[i].message_type == "list"){
                            let parse = JSON.parse(outgoing[i].data)
                            outgoing[i].parsedList = parse
                        }
                    }
                    this.table.rows = outgoing
                    this.hasMore = Array.isArray(outgoing) && outgoing.length === this.table.serverParams.limit
                } catch (err) {
                    console.log(err)
                    this.$toast.error("Too many request");
                }
                this.table.isLoading = false
            },
            async getFromServer(param) {
                // Build query for cursor-based pagination: limit & last_id
                const payload = {
                    limit: param.limit,
                };
                if (param.last_id) {
                    payload.last_id = param.last_id;
                }
                // Merge filters and sort if backend supports them alongside cursor
                const mergedFilters = Object.assign({}, param.columnFilters || {});
                if (this.deviceFilter) {
                    mergedFilters.device_id = String(this.deviceFilter);
                }
                if (Object.keys(mergedFilters).length) {
                    payload.columnFilters = JSON.stringify(mergedFilters);
                }
                if (param.sort && param.sort.length && param.sort[0].field) {
                    payload.sort = param.sort;
                }
                return await this.$store.dispatch("outgoing_list", payload);
            },
        },
    };
</script>

<style scoped>
    .margin5 {
        margin: 5px;
    }
</style>
